// Each re-poll of a degraded billing read triggers a real vendor probe server-side,
// so it runs on a slower cadence than the cheap temporary-state polling.
export const UNAVAILABLE_POLL_INTERVAL_MS = 30 * 1000;

// Stop auto-polling unavailable vendor data after ~2 minutes; the UI then offers a manual retry.
export const UNAVAILABLE_GIVE_UP_MS = 2 * 60 * 1000;

export const UNAVAILABLE_MAX_RETRIES = UNAVAILABLE_GIVE_UP_MS / UNAVAILABLE_POLL_INTERVAL_MS;

/**
 * Tracks how long a billing read has been reporting unavailable data.
 *
 * Create one per query at module scope so every mounted observer of that query
 * shares a single wall-clock give-up deadline (the billing hooks are mounted
 * from several components at once).
 */
export const createUnavailableTracker = () => {
  let unavailableSinceMs: number | null = null;

  return {
    track: (isUnavailable: boolean) => {
      if (!isUnavailable) {
        unavailableSinceMs = null;
      } else if (unavailableSinceMs === null) {
        unavailableSinceMs = Date.now();
      }
    },
    isGiveUpReached: () => unavailableSinceMs !== null && Date.now() - unavailableSinceMs >= UNAVAILABLE_GIVE_UP_MS,
    reset: () => {
      unavailableSinceMs = null;
    },
  };
};
